import { render, staticRenderFns } from "./BdcColumnFilterButton.vue?vue&type=template&id=76d2ec80"
import script from "./BdcColumnFilterButton.vue?vue&type=script&lang=js"
export * from "./BdcColumnFilterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports